import { Button, Card, Col, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

import Footer from "../../components/layout/footers/Footer";
import UsdtRed from "../../assets/images/usdt-red.jpeg";
import Bank from "../../assets/images/atm.jpg";
import { ROUTE } from "../../constants/app_routes";
import BaseLayout from "../../components/layout";
import { formatCurrency } from "../../utils/math";
import {
  useProfileQuery,
  useQueryUsdt,
} from "../../graphql/apollo/query-hooks";
import { btc, trc } from "../../constants/image_path";
import { ChevronRightIcon } from "../../constants/icon_path";

const Topup = () => {
  const { t } = useTranslation();
  const { memberProfile } = useProfileQuery();
  const { digitalWallets } = useQueryUsdt();

  const renderMenu = ({ data, title, icon, symbol }) => {
    return (
      <Link
        to={ROUTE.TOPUP_COIN_DETAIL.replace(":symbol", symbol?.toLowerCase?.() ?? "coin")}
        state={data}
        className="btn"
        key={symbol}
      >
        <Row className="align-items-center">
          <Col xs="2" md="2" sm="2">
            <div className=" recharge__submit-avatar">
              <img className="img-thumbnail" src={icon} alt={title} />
            </div>
          </Col>
          <Col xs="10" md="10" sm="10">
            <div className="d-flex justify-content-between align-items-center">
              <div className="text">
                <h5 className="mb-0">{title}</h5>
              </div>
              <ChevronRightIcon className="chevron" size={30} />
            </div>
          </Col>
        </Row>
      </Link>
    );
  };

  return (
    <BaseLayout>
      <div className="topup">
        <Card bg="success" style={{ height: "60px" }}>
          <Card.Body>
            <h3 className="balance-text text-center">
              {t("balance")}: {formatCurrency(memberProfile?.balance ?? 0)}
            </h3>
          </Card.Body>
        </Card>
        <Card>
          <Link
            to={ROUTE.TOPUP_BANK_CARD}
            state={{
              logo: UsdtRed,
              name: t("bankPayment"),
              isBank: true,
            }}
          >
            <div className="account-type d-flex">
              <img className="logo-type img-thumbnail" src={Bank} alt="usdt" />
              <h3>{t("bankCard")}</h3>
            </div>
          </Link>
          <h3 className="m-2">Deposit USDT</h3>
          <hr />
          {renderMenu({ data: digitalWallets?.btc, title: "BTC", icon: btc, symbol: "BTC" })}
          <hr />
          {renderMenu({ data: digitalWallets?.usdt, title: "USDT", icon: trc, symbol: "USDT" })}
        </Card>
        <div>
          <div className="d-flex mt-3 justify-content-center">
            <Link to={ROUTE.TOPUP_RECORD}>
              <Button variant="info" className="text-white">
                {t("viewCardRecord")}
              </Button>
            </Link>
            <Link to={ROUTE.SUPPORT}>
              <Button variant="primary">{t("supportText")}</Button>
            </Link>
          </div>
        </div>
        <Footer />
      </div>
    </BaseLayout>
  );
};

export default Topup;
